<template>
  <v-row>
    <v-col cols="12" sm="6">
      <FileUpload
        @attachment-file-add="addFile"
        @file-delete="deleteFile"
        :file="passport_1"
        label="Первый разворот паспорта"
        name="passport_1"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <FileUpload
        @attachment-file-add="addFile"
        @file-delete="deleteFile"
        :file="passport_2"
        label="Страница со штампом регистрации"
        name="passport_2"
      />
    </v-col>
  </v-row>
</template>

<script>
import FileUpload from "@/components/common/AttachmentUpload.vue";
import { addFile, deleteFile } from "@/api/profile";

export default {
  props: {
    oid: String,
    files: {
      type: Array | null,
    },
  },
  computed: {
    passport_1() {
      return (this.files && this.files.find((file) => file.doc_type === "passport_1")) || null;
    },
    passport_2() {
      return (this.files && this.files.find((file) => file.doc_type === "passport_2")) || null;
    },
  },
  methods: {
    async addFile({ id, name }) {
      try {
        const res = await addFile(id, name, this.oid);
        if (res) {
          this.$emit("file-add");
        }
      } catch (e) {
        console.error(e);
      }
    },
    async deleteFile(id) {
      try {
        const res = await deleteFile(id, this.oid);
        if (res) {
          this.$emit("file-delete");
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    FileUpload,
  },
};
</script>
